import { useOrgUsers } from './useOrgUsers';
export const useOrgUser = (param: {
  orgId: number | undefined;
  userId: number | undefined;
}) => {
  const { orgId, userId } = param;

  const { data: orgUsers } = useOrgUsers(orgId);
  const user = orgUsers?.find((u) => u.id === userId);
  return user;
};
